module.exports = __webpack_public_path__ + "img/Butterfly_00187.b91684fa.png";